import { render } from "./event_speaker.html?vue&type=template&id=bf444f00&external"
import script from "./event_speaker.js?vue&type=script&lang=js&external"
export * from "./event_speaker.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__